import { Card } from 'design-system/src/components/Card';
import Button from 'design-system/src/components/Button/Button';
import { Typography } from 'design-system/src/components/Typography/Typography';
import styled from 'styled-components';
import Logo from 'design-system/src/assets/icons/logoLong.svg?react';
import { PageContainer, CardContent, CardTextSection, CardFormSection } from './styles';
import SignupFlowContent from './SignupFlowContent';

const LogoWrapper = styled.div`
  margin-bottom: 32px;
  display: flex;
  align-items: flex-start;
`;

const Subtitle = styled(Typography)`
  color: var(--dark-gray);
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export type NewPracticeOrJoinProps = {
  className?: string;
  onJoinExisting: () => void;
  onCreateNew: () => void;
};

export const NewPracticeOrJoin = ({ className, onJoinExisting, onCreateNew }: NewPracticeOrJoinProps) => {
  return (
    <PageContainer className={className}>
      <Card>
        <CardContent>
          <LogoWrapper>
            <Logo height={32} />
          </LogoWrapper>
          <CardTextSection>
            <SignupFlowContent />
          </CardTextSection>
          <CardFormSection>
            <Subtitle styledAs="bodyLargeDMSans">
              Select an option below so we know how to set up your account.
            </Subtitle>
            <ButtonGroup>
              <Button
                variant="secondary"
                width="full"
                textStyledAs="bodySmallDMSans"
                textWeight={700}
                onClick={onJoinExisting}
              >
                My practice is already using Tandem
              </Button>
              <Button
                variant="primary"
                width="full"
                textStyledAs="bodySmallDMSans"
                textWeight={700}
                onClick={onCreateNew}
              >
                My practice wants to start using Tandem
              </Button>
            </ButtonGroup>
          </CardFormSection>
        </CardContent>
      </Card>
    </PageContainer>
  );
};

export default NewPracticeOrJoin;
